import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/admin"); return; }
    const sessionId = m[1];
    api.post("/auth/process-session", { session_id: sessionId })
      .then((r) => {
        if (r.data?.is_admin) navigate("/admin/dashboard", { state: { user: r.data } });
        else navigate("/admin?error=unauthorized");
      })
      .catch(() => navigate("/admin?error=auth"));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-neutral-400">
      <p>Signing you in…</p>
    </div>
  );
}
